
import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES,useParams } from './../../common/helper/common-imports.component.js';
import { initialFormData, initialErrors, fieldValidation, createMerchantData  } from '../../common/helper/form-constants.js';
import CryptoService from "../../../services/crypto-service.js";
import { FormField, SelectField } from './../../common/helper/formFields';

const ApproveCrypto = () => {
  const [activeTab, setActiveTab] = useState('per_details');
  const [activeTabType, setActiveTabType] = useState('ERC');
  const [formData, setFormData] = useState({
    quantity:''
   });
  const [errors, setErrors] = useState({ ...initialErrors });
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState([]);
  const [imageUrlTRC, setImageUrlTRC] = useState('');
  const [sellImageUrl, setSellImageUrl] = useState('');
  const [exchange, setExchange] = useState('ERC');
  const [crypto, setCrypto] = useState();
  const [options, setOptions] = useState([]);
 const [formDataBuy, setFormDataBuy] = useState([]);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState([]);
  const [imagePreviews, setImagePreviews] = useState({});
const [sellImageRequest,setSellImageRequest] =  useState();
const { id } = useParams();
const handleCopy = (textToCopy) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        toast.success(MESSAGES.TXT_COPIED);
      })
      .catch(err => {
        console.error('Failed to copy:', err);
        toast.error(MESSAGES.TXT_CPY_FAILED);
      });
  } else {
    // Fallback for unsupported browsers
    const textArea = document.createElement('textarea');
    textArea.value = textToCopy;
    textArea.style.position = 'fixed';  // Prevent scrolling to bottom of page in MS Edge.
    textArea.style.opacity = '0';       // Make the textarea invisible

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
      document.body.removeChild(textArea);
      toast.success(MESSAGES.TXT_COPIED);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
      toast.error(MESSAGES.TXT_CPY_FAILED);
      document.body.removeChild(textArea);
    }
  }
};
const handleDownload = (image) => {
  window.open(image, '_blank');
};
  const toggleDropdown = () => {
      setIsOpen(!isOpen);
  };

 
  const getCryptoList = (e) => {
    setLoading(true);
    CryptoService.viewCrypto(id)
      .then(response => {
        let data = response.data.data;
        console.log(data)
        let optionsRecord = []
       
          optionsRecord.push({
            requested_quantity:data.requested_quantity,value: data.crypto_id, label:  data.crypto_code, image: '/assets/usdt.png',details:data.details
          })
          if (data && data.details) {
            const initialFormData = data.details.map((option) => ({ value: '', type: option.exchange }));
            const intialImage = data.details.map((option) => ({ file: '', type: option.exchange }));
            console.log(initialFormData)
            setFormDataBuy(initialFormData);
            setImageUrl(intialImage)
          }
        setOptions(optionsRecord)
        setCrypto(data)
        setSelectedOption(optionsRecord[0]);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        console.error("Error fetching agents:", error);
      });
   
  }
  useEffect(() => {
   
    getCryptoList();
    document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
  }, []);

 
  const validateFields = (fields, formData) => {
    let isValid = true;
    fields.forEach(fieldName => {
      const fieldValue = formData[fieldName];
      if (!fieldValue || !fieldValue.trim()) {
        validateField(fieldName, fieldValue || ''); 
        isValid = false;
      }
    });
    
    return isValid;
  };

  const approve = (e)=> {
    e.preventDefault();
    

    let requiredFields = ['approvedQty','approvedRate','remarksCrypto'];
    if (!validateFields(requiredFields, formData)) {
      return
    } 
    let formIsValid = true;
    
    
    
  
  if(crypto.request_type == 'B') {
  
    let newErrors = {};
    formDataBuy.forEach((item, index) => {
    //   const errorMessage = validateFieldNew(index, 'transactionID', item.value);
    //  if(errorMessage) {
    //   formIsValid = false;
    //   newErrors[`${index}-transactionID`] = errorMessage;
    //  }
    });
    imageUrl.forEach((item, index) => {
      if(item.type == "TRC") {
        // if(!item.file){
        //   toast.error('Please upload TRC file');
        //   formIsValid = false;
        // }
        
      }
      if(item.type == "ERC") {
        // if(!item.file){
        //   toast.error('Please upload ERC file');
        //   formIsValid = false;
        // }
      }
    })
    if (!formIsValid) {
      setErrors(newErrors);
      return;
    }
  }
  
   let request = ''
   if(crypto.request_type == 'B') {
    let ercFile = imageUrl.filter(item => item.exchange == 'ERC')[0];
    let trcFile = imageUrl.filter(item => item.exchange == 'TRC')[0];
    let ercAddress = formDataBuy.filter(item => item.type == 'ERC')[0];
    let trcAddress = formDataBuy.filter(item => item.type == 'TRC')[0];

    
    if(!ercFile && !ercAddress.value) {
      toast.error('Please upload ERC Address or ERC payment proof')
      return
    }
    if(!trcFile && !trcAddress.value) {
      toast.error('Please upload TRC Address or TRC payment proof')
      return
    }
    const data = new FormData();
    data.append('cryptoId',id);
    if(ercFile) {
      data.append('ercFile',ercFile.file);
    }
    if(trcFile) {
      data.append('trcFile',trcFile.file);
    }
    
   
    data.append('ercTxnId',ercAddress.value);
    data.append('trcTxnId',trcAddress.value);
    data.append('approvedQuantity',formData.approvedQty);
    data.append('approvedRate',formData.approvedRate);
    data.append('remarks',formData.remarksCrypto);
    data.append('accept','Y');

    request =  CryptoService.updateCryptoStatus(data,id,'buy')
    
   } else {
    const data = new FormData();
    data.append('cryptoId',id);
    data.append('approvedQuantity',formData.approvedQty);
    data.append('approvedRate',formData.approvedRate);
    data.append('remarks',formData.remarksCrypto);
    data.append('accept','Y');
    data.append('screenshot',selectedOption.details[0].screenshot_url);
    request =  CryptoService.updateCryptoStatus(data,id,'sell')
   }
   
      setLoading(true);
      request
        .then(response => {
          toast.success(MESSAGES.CRYPTO_APPROVED);
          navigate('/crypto?userType='+crypto.user_type.toLowerCase()); 
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
          try {
            const errorMessage = error.response.data
            toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
          } catch (e){
            toast.error( MESSAGES.SERVER_ERROR)
          }
        });
  }
  const handleChangeBuySell = (index, e, exchange) => {
    const newFormData = [...formDataBuy];
    if (!newFormData[index]) {
      newFormData[index] = {};
    }
    newFormData[index] = { value: e.target.value, type: exchange };
    setFormDataBuy(newFormData);
    validateFieldNew(index, 'transactionID', e.target.value);
  };

  const validateFieldNew = (index, fieldName, value) => {
    let newErrors = { ...errors };
    const errorMessage = fieldValidation(fieldName, value);
    if (errorMessage) {
      newErrors[`${index}-${fieldName}`] = errorMessage;
     } else {
       delete newErrors[`${index}-${fieldName}`];
     }
    
    setErrors(newErrors);
    return errorMessage;
  };

  const reject = (e)=> {
    let requiredFields = ['remarksCrypto'];
    if (!validateFields(requiredFields, formData)) {
      return
    } 
    let request = ''
    const data = new FormData();
    data.append('remarks',formData.remarksCrypto);
    data.append('accept','N');
   if(crypto.request_type == 'B') {
    request =  CryptoService.updateCryptoStatus(data,id,'buy')
   }else {
    request =  CryptoService.updateCryptoStatus(data,id,'sell')
   }
    setLoading(true);
    request
      .then(response => {
        toast.success(MESSAGES.CRYPTO_REJECTED);
        navigate('/crypto?userType='+crypto.user_type.toLowerCase()); 
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        try {
          const errorMessage = error.response.data
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
        } catch (e){
          toast.error( MESSAGES.SERVER_ERROR)
        }
      });
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
   
  };
  const validateField = (fieldName, value) => {
    const errorMessage = fieldValidation(fieldName, value);
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
    return errorMessage
  };
  
  const setTabType = (tab) => {
    if(tab =='ERC') {
        setExchange('ERC')
    } else {
        setExchange('TRC')
    }
    
    setActiveTabType(tab);
  };
  const handleFileChange  = (index,e,exchange) => {
    const file = event.target.files[0];
    const maxSize = 2 * 1024 * 1024; // 2 MB

    if (!file.type || !file.type.startsWith('image/')) {
      toast.error('Please select an image file.');
      return;
    }

    if (file && file.size <= maxSize) {
      const file = e.target.files[0];
      const newImageFiles = [ ...imageUrl ];
      const newImagePreviews = { ...imagePreviews };
  
      newImageFiles[index] = {file:file,exchange:exchange};
      newImagePreviews[index] = URL.createObjectURL(file);
  
      setImageUrl(newImageFiles);
      setImagePreviews(newImagePreviews);
      
    } else {
      setImageUrl('');
      toast.error('File size exceeds 2 MB. Please select a smaller file.');
    }

  }
  const back = () => {
    navigate('/crypto?userType='+crypto.user_type.toLowerCase()); 
  }

  return (
    <div>
    <LoaderOverlay loading={loading} />
    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
    <h4 style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Crypto Approve/Reject</h4>
      <div className="container-fluid ghty" style={{backgroundColor: 'white',float:'left',marginBottom:'25px'}}>
       
          <ul className="nav nav-tabs" style={{'cursor':'pointer'}}>
            {crypto && crypto.request_type == 'B' && (
                <li className="nav-item tbbtrn" >
                <a className={`nav-link active_tab1 }`} id="list_per_details">BUY</a>
              </li>
            )}
             {crypto && crypto.request_type == 'S' && (
            <li className="nav-item tbbtrn">
              <a className={`nav-link active_tab1`} id="list_address_details">SELL</a>
            </li>
             )}
          </ul>
          <div className="tab-content" style={{marginTop: '16px'}}>
          
            
            <form onSubmit={approve}  className='tab-content'>
            {/* Sell Starts here */}
            <div className={`tab-pane ${activeTab==='per_details' ? 'active' : 'fade' }`} id="per_details">
              <div className="panel panel-default">
                <div className="panel-body" style={{padding: '0px'}}>
                  <div className="container col-md-12" style={{padding: 0, width:'100%'}}>
                  <div style={{width:'100%',float:'left'}} className='frm'>
                    <div className="col-md-4 crypto" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="custom-dropdown"  style={{ marginTop: errors.quantity ? '-10px' : '11px' }}>
                        <div className="selected-option" onClick={toggleDropdown}>
                            {selectedOption ? (
                                <div className="selected">
                                    <img src={selectedOption.image} width={'23px'} alt={selectedOption.label} className="dropdown-image" />
                                   <span> {selectedOption.label}</span>
                                </div>
                            ) : (
                                <div className="placeholder">Select an option</div>
                            )}
                            <div className={`arrow ${isOpen ? 'open' : ''}`}></div>
                        </div>
                        {/* {isOpen && (
                            <div className="options">
                                {options.map((option) => (
                                    <div key={option.value} className="option" onClick={() => selectOption(option)}>
                                        <img src={option.image} width={'10px'} alt={option.label} className="dropdown-image" />
                                       <span>{option.label}</span> 
                                    </div>
                                ))}
                            </div>
                        )} */}
                    </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <FormField type="text" margin={'0'} isRequierd={false} id="f_name" name="quantity" value={selectedOption.requested_quantity} placeholder="Enter Quantity" disabled={true}/>
                      </div>
                      
                    </div>
                    </div>
                    <div className="container col-md-12" style={{padding: 0}}>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                     
                      <FormField
                           type="text"
                           isRequierd = {true}
                           id="addressLine1"
                           name="approvedQty"
                           label="Approved Quantity"
                           placeholder = "Approved Quantity"
                          
                           onChange={handleChange}
                           error={errors.approvedQty}
                           maxlength = {50}
                          
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="textarea"
                           isRequierd = {true}
                           id="addressLine1"
                           name="remarksCrypto"
                           label="Remarks"
                           placeholder = "Remarks"
                          
                           onChange={handleChange}
                           error={errors.remarksCrypto}
                           maxlength = {500}
                           height = {'50px'}
                        />
                    </div>
                  </div>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                     
                      <FormField
                           type="number"
                           isRequierd = {true}
                           id="addressLine1"
                           name="approvedRate"
                           label="Approved Rate"
                           placeholder = "Approved Rate"
                         
                           onChange={handleChange}
                           error={errors.approvedRate}
                           maxlength = {50}
                        />
                    </div>
                   
                  </div>
                </div>
                
                    {/* <div style={{width:'100%',float:'left'}} className='frm'>
                    <div className="col-md-4 crypto" style={{padding: '0px', paddingRight: '30px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <FormField type="number" margin={'0'} isRequierd={true} id="f_name" name="quantity" label = "Approved Quantity"value={selectedOption.requested_quantity} placeholder="Enter Quantity" />
                      </div>
                      
                    </div>
                    </div>

                    <div style={{width:'100%',float:'left'}} className='frm'>
                    <div className="col-md-4 crypto" style={{padding: '0px', paddingRight: '30px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <FormField type="number" margin={'0'} isRequierd={true} id="f_name" name="quantity" label = "Approved Rate"  placeholder="Enter Quantity" />
                      </div>
                      
                    </div>
                    </div> */}

                    <div style={{width:'100%',float:'left'}} className='frm'>
                      <ul className="nav nav-tabs"  style={{'cursor':'pointer'}}>
                      
                        <li className="nav-item tbbtrn">
                          <a className={`nav-link active`} >Address Information</a>
                        </li>
                     
                      </ul>
                      
                    </div>
                    {selectedOption && selectedOption.details && selectedOption.details.map((option, index) => ( 
                      <>
                      <div className='col-md-12' style={{width:'50%'}}>
                      <div class="tab-content">
                    <div  className={`frm tab-pane active`}>
                        <div className='col-md-4'>
                        {crypto.request_type == 'S' && option.screenshot_url &&(
                          <>
                          <img style={{width:'136px', paddingTop:'12px'}} src={option.screenshot_url}></img>
                          <p  onClick={() => handleDownload(option.screenshot_url)} style={{'textAlign':'center', 'paddingRight':'40px', 'cursor':'pointer'}}>  <i class="fa fa-download"  style={{color:'black', cursor:'pointer'}}></i> Download</p>
                          </>
                        )}
                          {crypto.request_type == 'B' && option.qr_code_url && (
                            <>
                             <img style={{width:'136px', paddingTop:'12px'}} src={option.qr_code_url}></img>
                            <p  onClick={() => handleDownload(option.qr_code_url)} style={{'textAlign':'center', 'paddingRight':'40px', 'cursor':'pointer'}}>  <i class="fa fa-download"  style={{color:'black', cursor:'pointer'}}></i> Download</p>
                            </>
                           
                         
                          
                        )}
                     
                        </div>
                        <div className='col-md-4' style={{paddingTop:'10px'}}>
                         {crypto.request_type == 'S' && (
                            <label >Transaction ID</label>
                         )}
                         {crypto.request_type == 'B' && (
                            <label >Address</label>
                         )}
                         {crypto.request_type == 'S' && (
                            <p>{option.transaction_id} <i class="fa fa-copy" onClick={() => handleCopy(option.transaction_id)}  style={{color:'black', cursor:'pointer'}}></i></p>
                         )}
                         {crypto.request_type == 'B' && (
                            <p>{option.address} <i class="fa fa-copy" onClick={() => handleCopy(option.address)}  style={{color:'black', cursor:'pointer'}}></i></p>
                         )}
                          
                          <FormField type="text" isRequierd={false} id="f_name" name="fullName" label="Exchange" value={option.exchange} placeholder="Exchange"  onChange={handleChange} maxlength={100} width={'250px'} disabled={true}/>
                        </div>
                      </div>
                      </div>
                 
                      </div>
                    </>
                    ))}



                        

                  </div>
                  {crypto && crypto.request_type == 'B' && (
                  <div className='tab-content' style={{width:'100%',float:'left'}}>
                  <ul className="nav nav-tabs"  style={{'cursor':'pointer'}}>
                
                        <li className="nav-item tbbtrn">
                          <a className={`nav-link active`} >Payment Information</a>
                        </li>
                     
                      </ul>
                      </div> 
                  )}
                  {selectedOption && selectedOption.details && selectedOption.details.map((option, index) => ( 
                      <>
                  {crypto && crypto.request_type == 'B' && (
                   
                     <div className='tab-content' style={{
                      width: '50%', // Adjust 'crypto.length' as needed
                      float: 'left'
                    }}>
                    
                    <div style={{width:'100%',float:'left'}} className={`frm tab-pane  active }`} >
       
                      <div className="col-md-12" style={{padding: '0px', marginTop: '20px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <FormField type="text" isRequierd={true} id="f_name" name={`transactionID`} label={`${option.exchange} Transaction ID`} placeholder={`${option.exchange}  Transaction ID`}   onChange={(e) => handleChangeBuySell(index, e,option.exchange)}  error={errors[`${index}-transactionID`]} maxlength={100} width={'250px'}/>
                      </div>
                      </div>
                      <div className="col-md-12" style={{padding: '0px', paddingRight: '30px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className='required'>{option.exchange} Upload Payment Proof</label>
                        <br></br>
                        <input style={{width: '250px', display: 'inline'}} type="file" className="form-control" accept="image/*" id="imageInput" name="f_name" onChange={(e) => handleFileChange(index, e,option.exchange)}/>
                        {imagePreviews[index] && (
                            <img src={imagePreviews[index]} alt="Preview" className="image-preview vjk" />
                            )}
                      </div>
                      </div>
                    </div>
                    </div> 
                      )}
                      </>
                    ))}
                  <br />
                  <div align="left" style={{width:'100%',float:'left'}}>
                    <div style={{width:'100%',marginBottom:'15px'}}>
                    <button type="submit" name="btn_login_details" id="btn_login_details" className="btn btn-success raisbt vtl" >Approve</button>
                    <button type="button" name="btn_login_details" id="btn_login_details" className="btn btn-danger raisbt " onClick={reject}>Reject</button>
                   <button className="btn btn-success backbt" style={{marginLeft:'6px'}} onClick={back}>Back</button>
                    </div>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            </form>
          </div>
      
      </div>
    </div>
  </div>
  );


  }

export default withAuth(ApproveCrypto);
